import { SVGProps } from 'react';

const SearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#71717A"
      d="M15.75 10.5a5.25 5.25 0 1 1-10.499 0 5.25 5.25 0 0 1 10.499 0Zm5.78 11.03a.749.749 0 0 1-1.06 0l-4.694-4.693a8.25 8.25 0 1 1 1.061-1.06l4.694 4.692a.748.748 0 0 1 0 1.062ZM10.5 17.25a6.75 6.75 0 1 0-6.75-6.75 6.758 6.758 0 0 0 6.75 6.75Z"
    />
  </svg>
);

export default SearchIcon;
